
const digest = '345788132b4d3c2ce6f20e2e632fc1d9d99859ab7479be4e8266e29a8423de66';
const css = `._codeSnippet_arpso_1 {
  font-family: monospace;
  color: var(--theme-code-text, #d14);
  border: 1px solid var(--theme-primary-border, #e1e1e1);
  padding: 0 4px;
  margin: 0;
  border-radius: 3px;
  background-color: var(--theme-secondary-background, #f7f7f7);
}
`;

(function() {
  if (!document.getElementById(digest)) {
    var el = document.createElement('style');
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
    
export default {"codeSnippet":"_codeSnippet_arpso_1"};
export { css, digest };
  